import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const RoleSet = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  // react hook form
  const { register, handleSubmit, reset } = useForm();

  // get role Data
  const {
    data: roleData,
    error,
    mutate,
  } = useSWR(`store/requisition/roles/all`, fetcher);
  // get Enployee data
  const { data: employeeOption, error: error1 } = useSWR(
    `hr/employee`,
    fetcher
  );

  // set Employee category select list
  let employeeCategory = [];
  if (employeeOption && employeeOption.length > 0) {
    employeeCategory = employeeOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.EMPLOYEE_ID;
      optionsItem.label = `${data.NAME_ENGLISH}=>${data.DESIGNATION}=>${data.DEPARTEMENT}`;
      return optionsItem;
    });
  }
  // handle Employee select;
  const handleEmployee = (name) => {
    setSelectedEmployee(name.value);
  };

  // Update Section
  const [getId, setGetId] = useState(null);

  //   Update Unit
  const onSubmitUpdate = (data) => {
    if (selectedEmployee) {
      data.emp_id = selectedEmployee;
    } else {
      data.emp_id = roleById.EMPLOYE_ID;
    }

    console.log(data);
    API.put(`store/requisition/roles/${getId}`, data).then((res) => {
      //console.log(res)
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Update",
          icon: "success",
          button: "Ok",
        });
        // reset1();
        mutate();

        PostStoreLog(2, "Role update");
        window.$("#edit_role").modal("hide");
      }
    });
  };

  const handleUpdate = (updateId) => {
    setGetId(updateId);
    //console.log(updateId)
  };

  // get role Data By ID
  const { data: roleById } = useSWR(
    getId ? `store/requisition/roles/id/${getId}` : null,
    fetcher
  );
  console.log(roleById);
  return (
    <>
      <Helmet>
        <title>Role - BBA STORE</title>
        <meta name="description" content="Unit- BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">Manage Role</h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div_store">
              <div className="col-12 col-md-6 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries
                  <span className="fw-bold ms-3 text-primary showEntry">
                    {roleData ? roleData.length : ""}
                  </span>
                </p>
              </div>
            </div>
            {!roleData ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="table-responsive data-table_store">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th colSpan="1">ID</th>
                      <th colSpan="2">Name</th>
                      <th colSpan="2">Department</th>
                      <th colSpan="2">Designation</th>
                      <th colSpan="2">Role</th>
                      <th colSpan="1">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roleData.map((item, index) => (
                      <tr key={index}>
                        <th>{item.ROLE_ID}</th>
                        <td colSpan="2">{item.NAME_ENGLISH}</td>
                        <td colSpan="2">{item.DEPARTEMENT}</td>
                        <td colSpan="2">{item.DESIGNATION}</td>
                        <td colSpan="2">{item.ROLE_NAME}</td>
                        <td className="text-center">
                          <button
                            data-bs-toggle="tooltip"
                            title="Edit"
                            type="button"
                            data-toggle="modal"
                            data-target="#edit_role"
                            onClick={() => {
                              handleUpdate(item.ROLE_ID);
                            }}
                            className="btn btn-outline-color px-3 me-2"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Edit Role Modal */}
      <div id="edit_role" className="modal custom-modal fade" role="dialog">
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Role</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body text-start">
              <form onSubmit={handleSubmit(onSubmitUpdate)}>
                <div className="container px-4">
                  <div className="row gx-5">
                    <div className="col-12 col-md-12 col-lg-12 mt-1">
                      <label htmlFor="Department">
                        Employee <span className="color-red">*</span>
                      </label>

                      <Select
                        onChange={handleEmployee}
                        style={{ borderRadius: "10px" }}
                        className="text-start"
                        placeholder={
                          roleById ? roleById.NAME_ENGLISH : "select"
                        }
                        options={employeeCategory}
                      />
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0 }}
                        value={employeeCategory}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="submit-section">
                  <button
                    type="submit"
                    className="btn btn-color_store px-5 py-2 rounded"
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-color_store px-5 ms-1 py-2 rounded"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleSet;
